import * as Mod1 from "./admin-automation-route-map";
import * as Mod2 from "./discourse/initializers/append-by-listener";
import * as Mod3 from "./discourse/initializers/automation-admin-plugin-configuration-nav";
const compatModules = {
  "admin-automation-route-map": Mod1,
  "discourse/initializers/append-by-listener": Mod2,
  "discourse/initializers/automation-admin-plugin-configuration-nav": Mod3,
};
export default compatModules;
